/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-09-16 14:14:53
 * @LastEditTime: 2022-09-16 14:25:42
 * @FilePath: /insurforce-backstage-platform-side/src/views/reportForm/task/request.js
 */
import request from '@/utils/request2';

// 任务列表
export function taskList(data) {
  return request.post('admin/report-manager/taskList', data);
}